import {
    FETCH_RESOURCE_LOADING,
    FETCH_RESOURCE_LOADED,
    FETCH_RESOURCE_ERROR,
} from '../actions/auxiliar_actions'

import {
    FETCH_GET_USER_DATA_SUCCESS,
    FETCH_GET_USER_LIST_SUCCESS,
    FETCH_ADD_USER_SUCCESS,
    FETCH_REMOVE_USER_SUCCESS,
    FETCH_GET_MODELS_BY_USER_SUCCESS,
    FETCH_REMOVE_USER_INITIALIZE,
    FETCH_GET_NEW_API_TOKEN_SUCCESS,
    FETCH_DELETE_API_TOKEN_SUCCESS,
    FETCH_SET_DARKMODE_SUCCESS,
    FETCH_GET_VALIDATION_USERID_SUCCESS,
    FETCH_CHANGE_USERID_SUCCESS,
    FETCH_CHANGE_PASSWORD_SUCCESS,
    FETCH_NEW_PASSWORD_SUCCESS
} from '../actions/user_actions'
import {
    FETCH_ADD_MODEL_SUCCESS,
    FETCH_EDIT_MODEL_SUCCESS,
    FETCH_DELETE_MODEL_SUCCESS,
    FETCH_VERSION_MODEL_SUCCESS,
    FETCH_DELETE_MODEL_INITIALIZE,
    FETCH_DELETE_VERSION_INITIALIZE
} from '../actions/model_actions'

export default (state = {}, action) => {
    switch(action.type){
        case FETCH_RESOURCE_LOADING: {
            return {...state, loading: state.loading + 1}
        }
        case FETCH_RESOURCE_LOADED: {
            return {...state, loading: true}
        }
        case FETCH_RESOURCE_ERROR: {
            return {...state, fetchError: action.payload, loading: false}
        }
        case FETCH_GET_USER_DATA_SUCCESS: {
            return {...state, user_logged: action.payload, fetchError: null}
        }
        case FETCH_GET_USER_LIST_SUCCESS: {
            return {...state, user_list: action.payload, fetchError: null}
        }
        case FETCH_ADD_USER_SUCCESS: {
            return {...state, user_added: action.payload, fetchError: null}
        }
        case FETCH_REMOVE_USER_SUCCESS: {
            return {...state, user_removed: action.payload, fetchError: null}
        }
        case FETCH_GET_MODELS_BY_USER_SUCCESS: {
            return {...state, user_models: action.payload, fetchError: null}
        }
        case FETCH_ADD_MODEL_SUCCESS: {
            return {...state, model_added: action.payload, fetchError: null}
        }
        case FETCH_EDIT_MODEL_SUCCESS: {
            return {...state, model_updated: action.payload, fetchError: null}
        }
        case FETCH_DELETE_MODEL_SUCCESS: {
            return {...state, model_deleted: action.payload, fetchError: null}
        }
        case FETCH_VERSION_MODEL_SUCCESS: {
            return {...state, version_operation: action.payload, fetchError: null}
        }
        case FETCH_REMOVE_USER_INITIALIZE: {
            return {...state, user_removed: null, fetchError: null}
        }
        case FETCH_DELETE_MODEL_INITIALIZE: {
            return {...state, model_deleted: null, fetchError: null}
        }
        case FETCH_DELETE_VERSION_INITIALIZE: {
            return {...state, version_operation: null, fetchError: null}
        }
        case FETCH_GET_NEW_API_TOKEN_SUCCESS: {
            return {...state, api_token: action.payload, fetchError: null}
        }
        case FETCH_DELETE_API_TOKEN_SUCCESS: {
            return {...state, api_token_deleted: action.payload, fetchError: null}
        }
        case FETCH_SET_DARKMODE_SUCCESS: {
            return {...state, dark_mode: action.payload, fetchError: null}
        }
        case FETCH_GET_VALIDATION_USERID_SUCCESS: {
            return {...state, userId_validated: action.payload, fetchError: null}
        }
        case FETCH_CHANGE_USERID_SUCCESS: {
            return {...state, userId_changed: action.payload, fetchError: null}
        }
        case FETCH_CHANGE_PASSWORD_SUCCESS: {
            return {...state, password_changed: action.payload, fetchError: null}
        }
        case FETCH_NEW_PASSWORD_SUCCESS: {
            return {...state, new_password: action.payload, fetchError: null}
        }
        default: {
            return state
        }
    }
}